import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { Text } from '@grandvisionhq/elements';
import { sortPrescriptionParameters, isNumber, PrescriptionValueUtils } from '@grandvisionhq/utils';
import { isNewPrescriptionAndUpload } from '../../../../utils/is-new-prescription-upload.js';
import { SummaryTitle } from '../../SummaryTitle/SummaryTitle.js';

const Wrapper = ({ children , title  })=>/*#__PURE__*/ React.createElement("div", {
        className: "glasses-configurator-footer-prescription-column"
    }, title && /*#__PURE__*/ React.createElement(SummaryTitle, null, title), children)
;
const PrescriptionSummaryColumn = ({ title , labels , parameters , fields , prescriptionType  })=>{
    const sortedParameterNames = sortPrescriptionParameters((parameters || []).map((p)=>p.name
    ));
    if ((CommerceToolsApi.isNewPrescription(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType)) && fields && parameters) {
        return /*#__PURE__*/ React.createElement(Wrapper, {
            title: title
        }, /*#__PURE__*/ React.createElement("ol", {
            className: "glasses-configurator-footer-prescription-column__fields"
        }, sortedParameterNames.map((name)=>isNumber(fields[name]) && labels[name] ? /*#__PURE__*/ React.createElement(PrescriptionColumnRow, {
                key: name,
                name: name,
                label: labels[name],
                value: fields[name]
            }) : null
        )));
    }
    if (CommerceToolsApi.isExistingCustomer(prescriptionType)) {
        return /*#__PURE__*/ React.createElement(Wrapper, {
            title: title
        }, /*#__PURE__*/ React.createElement(Text, {
            variant: "body"
        }, labels.existingCustomer));
    }
    if (CommerceToolsApi.isEmailPrescription(prescriptionType)) {
        return /*#__PURE__*/ React.createElement(Wrapper, {
            title: title
        }, /*#__PURE__*/ React.createElement(Text, {
            variant: "body"
        }, labels.emailPrescription));
    }
    return null;
};
var ref;
const PrescriptionColumnRow = ({ label , name , value  })=>/*#__PURE__*/ React.createElement("li", {
        className: "glasses-configurator-footer-prescription-column__row"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "glasses-configurator-footer-prescription-column__label"
    }, `${label} `), /*#__PURE__*/ React.createElement("strong", {
        className: "glasses-configurator-footer-prescription-column__value"
    }, (ref = PrescriptionValueUtils.formatPrescriptionValue(name, value)) !== null && ref !== void 0 ? ref : ''))
;

export { PrescriptionColumnRow, PrescriptionSummaryColumn as default };
//# sourceMappingURL=PrescriptionSummaryColumn.js.map
